import { render, staticRenderFns } from "./TeamMemberDetails.vue?vue&type=template&id=636738f8&scoped=true&"
import script from "./TeamMemberDetails.vue?vue&type=script&lang=js&"
export * from "./TeamMemberDetails.vue?vue&type=script&lang=js&"
import style0 from "./TeamMemberDetails.vue?vue&type=style&index=0&id=636738f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636738f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('636738f8')) {
      api.createRecord('636738f8', component.options)
    } else {
      api.reload('636738f8', component.options)
    }
    module.hot.accept("./TeamMemberDetails.vue?vue&type=template&id=636738f8&scoped=true&", function () {
      api.rerender('636738f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamMembers/TeamMemberDetails.vue"
export default component.exports